import { defineComponent as m, openBlock as o, createElementBlock as l, mergeProps as d, unref as e, renderSlot as H, createElementVNode as n, createCommentVNode as p } from "vue";
import { useScalarIcon as i } from "../hooks/useScalarIcon.js";
const u = { key: 0 }, M = { key: 1 }, g = { key: 2 }, L = { key: 3 }, f = { key: 4 }, h = { key: 5 }, k = {
  name: "ScalarIconEnvelope"
}, A = /* @__PURE__ */ m({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(Z) {
    const r = Z, { bind: s, weight: a } = i(r);
    return (V, t) => (o(), l("svg", d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      H(V.$slots, "default"),
      e(a) === "bold" ? (o(), l("g", u, t[0] || (t[0] = [
        n("path", { d: "M224,44H32A12,12,0,0,0,20,56V192a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V56A12,12,0,0,0,224,44Zm-96,83.72L62.85,68h130.3ZM92.79,128,44,172.72V83.28Zm17.76,16.28,9.34,8.57a12,12,0,0,0,16.22,0l9.34-8.57L193.15,188H62.85ZM163.21,128,212,83.28v89.44Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (o(), l("g", M, t[1] || (t[1] = [
        n("path", {
          d: "M224,56l-96,88L32,56Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48Zm-96,85.15L52.57,64H203.43ZM98.71,128,40,181.81V74.19Zm11.84,10.85,12,11.05a8,8,0,0,0,10.82,0l12-11.05,58,53.15H52.57ZM157.29,128,216,74.18V181.82Z" }, null, -1)
      ]))) : e(a) === "fill" ? (o(), l("g", g, t[2] || (t[2] = [
        n("path", { d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM98.71,128,40,181.81V74.19Zm11.84,10.85,12,11.05a8,8,0,0,0,10.82,0l12-11.05,58,53.15H52.57ZM157.29,128,216,74.18V181.82Z" }, null, -1)
      ]))) : e(a) === "light" ? (o(), l("g", L, t[3] || (t[3] = [
        n("path", { d: "M224,50H32a6,6,0,0,0-6,6V192a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A6,6,0,0,0,224,50Zm-96,85.86L47.42,62H208.58ZM101.67,128,38,186.36V69.64Zm8.88,8.14L124,148.42a6,6,0,0,0,8.1,0l13.4-12.28L208.58,194H47.43ZM154.33,128,218,69.64V186.36Z" }, null, -1)
      ]))) : e(a) === "regular" ? (o(), l("g", f, t[4] || (t[4] = [
        n("path", { d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48Zm-96,85.15L52.57,64H203.43ZM98.71,128,40,181.81V74.19Zm11.84,10.85,12,11.05a8,8,0,0,0,10.82,0l12-11.05,58,53.15H52.57ZM157.29,128,216,74.18V181.82Z" }, null, -1)
      ]))) : e(a) === "thin" ? (o(), l("g", h, t[5] || (t[5] = [
        n("path", { d: "M224,52H32a4,4,0,0,0-4,4V192a12,12,0,0,0,12,12H216a12,12,0,0,0,12-12V56A4,4,0,0,0,224,52Zm-96,86.57L42.28,60H213.72ZM104.63,128,36,190.91V65.09Zm5.92,5.43L125.3,147a4,4,0,0,0,5.4,0l14.75-13.52L213.72,196H42.28ZM151.37,128,220,65.09V190.91Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  A as default
};
